var AuthPlugin = {
  setToken: function (token) {
    localStorage.setItem('authToken', token)
  },

  setRefreshToken: function (token) {
    localStorage.setItem('refreshToken', token)
  },

  destroyToken: function () {
    localStorage.removeItem('authToken')
    localStorage.removeItem('authTokenExpiration')
  },

  setMe: function (me) {
    localStorage.setItem('me', JSON.stringify(me))
  },

  getMe: function () {
    return JSON.parse(localStorage.getItem('me'))
  },

  isAdmin: function () {
    var me = JSON.parse(localStorage.getItem('me'))
    if (!me) return false
    return me.is_zadmin
  },

  removeMe: function () {
    localStorage.removeItem('me')
  },

  getInfo: function () {
    return localStorage.getItem('showed')
  },

  setInfo: function () {
    localStorage.setItem('showed', "showed")
  },

  getToken: function () {
    var token = localStorage.getItem('authToken')

    return token
  },
  isLoggedIn: function () {
    return !!this.getToken()
  }
}

export default function (app) {
  app.config.globalProperties.$auth = AuthPlugin
}